Core.PortalCheckoutHomeModification = (function() {
    var NS = 'checkoutHomeModification';
    var fileUploadObj = null;
    var map = null;
    var pop = null;

    function executeCallback(clb) {
        clb();
    };

    function countFiles() {
        return document.querySelectorAll('#checkoutHomeModification .fileUpload-fileList input[type=hidden]').length;
    }

    function OptionsError() {
        return {
            show() {
                if ($( ".error-options" ).length) {
                    return;
                }

                $('.fileUpload').append('<label class="error error-options">Please add instructions or attachments if you require home modification</label>');
            },

            clear() {
                $('.error-options').remove();
            }
        }
    }

    var v = {};

    /*


        DATA


     */

    var d = {
        state: '',
        installer: '',
        instructions: '',
        fileCounter: 0,
        subscriberList: {
            selectedState: [],
            selectedInstaller: [],
            textInstructions: [],
            files: [],
        },

        set selectedState(state) {
            this.state = state;
            this.selectedInstaller = '';

            d.subscriberList.selectedState.forEach(executeCallback);
        },

        get selectedState() {
            return this.state;
        },

        set selectedInstaller(installer) {
            this.installer = installer;

            d.subscriberList.selectedInstaller.forEach(executeCallback);
        },

        get selectedInstaller() {
            return this.installer;
        },

        set textInstructions(instructions) {
            this.instructions = instructions;

            d.subscriberList.textInstructions.forEach(executeCallback);
        },

        get textInstructions() {
            return this.instructions;
        },

        set files(count) {
            this.fileCounter = count;

            d.subscriberList.files.forEach(executeCallback);
        },

        get files() {
            return this.fileCounter;
        },

        subscribe(name, callback) {
            d.subscriberList[name].push(callback);
        }
    };


    /*


        METHODS


     */

    var m = {
        init: function() {
            m.initFilesUpload();

            m.loadVar();
            m.loadCallback();

            m.updateState();
            m.onStateChange();

            m.updateInstallerSelect();

            m.updateDetails();

            m.onTextInstructionsChange();
            m.onFilesChange();
            m.initMap();
            m.goTo();

            m.listenBtnClick();
            m.initModal();
            m.setValidators();

            m.onBtnClick();
            m.initDrawingTool();
        },

        initFilesUpload: function() {
            var uploaderList = Array.from(document.querySelectorAll('#checkoutHomeModification .fileUpload'));

            uploaderList.forEach(function(elem) {
                fileUploadObj = new Core.FileUpload(elem);
                fileUploadObj.init();
            });
        },

        loadVar: function() {
            d.selectedState = $(".selectedState").val();
            d.selectedInstaller = $(".selectedInstaller").val();
            d.textInstructions = $("#homeModificationInstructions").val();
            d.files = countFiles();
        },

        loadCallback: function() {
            d.subscribe('selectedState', m.updateInstallerSelect);
            d.subscribe('selectedState', m.isValidState);

            d.subscribe('selectedInstaller', m.updateDetails);
            d.subscribe('selectedInstaller', m.goTo);

            d.subscribe('textInstructions', m.isValidOptions);
            d.subscribe('files', m.isValidOptions);
        },

        setValidators: function() {
            v['state'] = new SelectValidator("#dropdownInstallerState");
            v['installer'] = new SelectValidator("#dropdownInstallerInState");
            v['options'] = {
                isValid: function() {
                    var error = new OptionsError();
                    var hasOption = (m.hasTextInstructions() || m.hasFiles());

                    hasOption
                        ? error.clear()
                        : error.show();

                    return hasOption;
                }
            }
        },

        isValidState: function() {
            setTimeout(v['state'].isValid, 100);
        },

        isValidInstaller: function() {
            setTimeout(v['installer'].isValid, 100);
        },

        isValidOptions: function() {
            setTimeout(v['options'].isValid, 100);
        },



        /*


            STATE


         */

        updateState: function() {
            var selectedState = d.selectedState;

            if (selectedState === '' || selectedState === 'all') {
                return;
            }

            $('#dropdownInstallerState').data("kendoDropDownList").value(selectedState);
        },

        onStateChange: function() {
            function updateDataState() {
                d.selectedState = $("#dropdownInstallerState").data("kendoDropDownList").value();
                $(".selectedState").val(d.selectedState);
                $(".selectedInstaller").val(d.selectedInstaller);
            };

            $("#dropdownInstallerState").data("kendoDropDownList").bind("change", updateDataState);
        },



        /*


            INSTALLERS


         */

        getInstallersList: function() {
            var selectedState = d.selectedState;

            function isInstallerInState(installer) {
                return installer.State
                    ? installer.State.toLowerCase() === selectedState.toLowerCase()
                    : false;
            }

            if (selectedState === '' || selectedState === 'all') {
                return [{Name: "Pick an installer", "Id": ""}];
            }


            if (typeof window.InstallersJson === 'undefined' || typeof window.InstallersJson.Installers === 'undefined') {
                return [{Name: "Pick an installer", "Id": ""}];
            }


            var installerListInState = window.InstallersJson.Installers.filter(isInstallerInState);
            return [{Name: "Pick an installer", "Id": ""}].concat(installerListInState);
        },

        getInstaller: function() {
            function isSelectedInstaller(installer) {
                return installer.Id === d.selectedInstaller;
            };

            return m.getInstallersList().find(isSelectedInstaller);
        },

        updateInstallerSelect: function() {
            var selectedInstaller = d.selectedInstaller;
            var installerList = m.getInstallersList();

            $("#dropdownInstallerInState").kendoDropDownList({
                dataSource: installerList,
                dataTextField: "Name",
                dataValueField: "Id"
            });

            $("#dropdownInstallerInState").data("kendoDropDownList").value(selectedInstaller);
            m.onInstallerChange();
        },

        onInstallerChange: function() {
            function updateDataInstaller() {
                d.selectedInstaller = $("#dropdownInstallerInState").data("kendoDropDownList").value();
                $(".selectedInstaller").val(d.selectedInstaller);
                m.isValidInstaller();
            };

            $("#dropdownInstallerInState").data("kendoDropDownList").bind("change", updateDataInstaller);
        },



        /*


            INSTRUCTIONS


         */

        onTextInstructionsChange: function() {
            function updateDataTextInstructions() {
                d.textInstructions = $("#homeModificationInstructions").val();
                m.isValidOptions();
            };

            $("#homeModificationInstructions").on("keyup", updateDataTextInstructions);
        },



        /*


            FILES


         */

        onFilesChange: function() {
            function updateDataFiles() {
                d.files = countFiles();
                m.isValidOptions();
            };

            document.addEventListener(`${NS}.fileUploaded`, updateDataFiles);
            document.addEventListener(`${NS}.fileDeleted`, updateDataFiles);
        },


        hasMinimumRequirements: function() {
            var hasOption = (m.hasTextInstructions() || m.hasFiles());

            return m.hasValidInstaller() && hasOption;
        },

        hasValidInstaller: function() {
            return (d.selectedInstaller !== '' && d.selectedState !== '');
        },

        hasTextInstructions: function() {
            return (d.textInstructions.length > 0);
        },

        hasFiles: function() {
            return (d.files > 0);
        },



        /*


            BUTTONS


         */

        checkBtn: function() {
           $("#btnContinueHomeMod").attr('disabled', ! m.hasMinimumRequirements());
        },

        onBtnClick: function() {
            var isSubmitted = false;
            var setIsSubmittedFalse = function() {
                isSubmitted = false;
            }

            var onClick = function() {
                m.isValidState();
                m.isValidInstaller();
                m.isValidOptions();

                if (! m.hasMinimumRequirements()) {
                    return;
                }

                // reorder file list names to send to server
                var $list = $('#checkoutHomeModification .fileUpload .fileUpload-fileList');
                $list.find('.fileUpload-file').each(function(i, item) {
                    var $file = $(item);
                    $file.find('.UploadedFiles').prop('name', `UploadedFiles[${i}]`);
                    $file.find('.UploadedOriginalFileNames').prop('name', `UploadedOriginalFileNames[${i}]`);
                });

                !isSubmitted &&
                    ( isSubmitted = true
                    , setTimeout(setIsSubmittedFalse, 500)
                    , $('#frmHomeModification').trigger('submit')
                    );
            };

            var btn = document.querySelector("#btnContinueHomeMod");
            btn && btn.addEventListener('click', onClick);
        },



        /*


            DETAILS


         */

        updateDetails: function() {
            var $desc = $('.home-mod-option-desc');
            var $details = $('.home-mod-details');
            var installer = m.getInstaller();

            if (!installer || !installer.AddressLine1) {
                $content = '&nbsp;';
                $desc.show();
                $details.html($content);
                $details.hide();
                return;
            }

            $content = '<h4>' + installer.Name + '</h4>'
                        + '<p>' + installer.AddressLine1 + '</p>'
                        + '<p>' + installer.Suburb + '</p>'
                        + '<p>' + installer.State + ', ' + installer.Postcode + '</p>'
                        + '<p>Phone: ' + installer.Phone + '</p>'
                        + (installer.BusinessHours ? '<p class="mt-3">Business Hours: </p> <div class="mt--3">' + installer.BusinessHours + '</div>' : '');

            $desc.hide();
            $details.html($content);
            $details.show();
        },



        /*


            MAP


         */

        initMap: function() {
            var $mapCanvas = $("#google-map-canvas-home-mod");

            if ($mapCanvas.length) {
                var data = (typeof window.InstallersJson === 'undefined' || typeof window.InstallersJson.Installers === 'undefined')
                    ? []
                    : window.InstallersJson.Installers;

                map = Core.Map($mapCanvas[0]);
                map.init();
                map.plotMarkers(data);
            }
        },

        goTo: function() {
            var installer = m.getInstaller();

            (!installer || !installer.AddressLine1)
                ? map.setState(d.selectedState)
                : map.goTo(installer.Latitude, installer.Longitude);
        },


        /*


            HOME MOD BUTTONS
            - listenBtnClick init both btns listners


         */

        listenBtnClick: function() {
            m.onClickBtnContinueHomeMod();
            m.onClickBtnNoHomeModRequired();
        },

        onClickBtnContinueHomeMod: function() {
            $("#btnContinueHomeMod").on('click', function(e) {
                e.preventDefault();

                $('.homeMods').val('true');

                $("#btnContinueHomeMod").unbind('click').trigger('click');
                setTimeout(m.onClickBtnContinueHomeMod, 250);
            });
        },

        onClickBtnNoHomeModRequired: function() {
            $("#btnNoHomeModRequired").on('click', function(e) {
                e.preventDefault();

                if (m.isModalNoHomeMod()) {
                    m.showModal();
                    return;
                }

                $('.homeMods').val('false');
                m.doClickNoHomeModRequired();
            });
        },

        // unbind click and bind event
        // required to submit the no home mode form
        doClickNoHomeModRequired: function() {
            $("#btnNoHomeModRequired").unbind('click').trigger('click');
            setTimeout(m.onClickBtnNoHomeModRequired, 250);
        },

        /*

            on ajax_homemods_OnComplete
            we fire `aidacare.home-mod-completed`
            portalCheckout will listen and refresh the cart items
            Core.PortalCheckoutHomeModification.homeModCompletedEvent()

         */
        homeModCompletedEvent: function() {
            var event = new Event('aidacare.home-mod-completed');
            document.dispatchEvent(event);

            // remove error message
            setTimeout(() => {
                var error = new OptionsError();
                error.clear();
                
                // remove files and notes if no home mod required clicked
                if ($('.homeMods').val().toLowerCase() === 'false') {
                    $('#checkoutHomeModification .fileUpload-fileList').empty();
                    $("#homeModificationInstructions").val('');
                    $('.drawingTool-canvas').drawr('clear');
                }
            }, 1000);
        },


        /*


            NO HOME MOD MODAL
            - if only product in the cart is home mod
            - if user click yes (which means remove)
              then we do remove and refresh the page


         */

        isModalNoHomeMod: function() {
            return $('#btnNoHomeModRequired').data("confirm") || m.hasMinimumRequirements();
        },

        showModal: function() {
            pop.data("kendoWindow").center().open();
        },

        initModal: function() {
            pop = $('#confirm')
                        .kendoWindow({
                            title: "CONFIRM NO HOME MOD",
                            visible: false,
                            iframe: false,
                            modal: true,
                            resizable: false,
                            pinned: true,
                            draggable: false,
                            animation: false,
                        });

            $('[data-name="no"]').on('click', function() {
                pop.data("kendoWindow").close();
            });

            $('[data-name="yes"]').on('click', function() {
                pop.data("kendoWindow").close();
                $('.homeMods').val('false');

                m.doClickNoHomeModRequired();
            });
        },

        initDrawingTool: function() {
            var $fileUploadEl = $('#checkoutHomeModification .fileUpload');

            if ($("#homeMod-draw").length > 0) {
                var drawingTool = new Core.DrawingTool("#homeMod-draw");
                drawingTool.init(fileUploadObj, $fileUploadEl);
            }
        },
    };

    return m;
})();
